import { Button, Empty, Input, List, message, Modal } from "antd";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { connect } from "dvajs";
import { useTranslation } from "react-i18next";
import { EbookState, MangeExternalModalInfo } from "@/models/ebook";
import { approveAccountEXP, getManagerApproveRecordsReq } from "@/api/ebook";
import { ApprExternalContacts } from "@/types/chat/State";
import "./index.less";
import { updateApprExternalContacts } from "@/api/chat";
import { setExternalContactsTipsTool, setManageNoticeTipsTool } from "@/utils/chat/index";
import dayjs from "dayjs";
import ExternalItem from "@/components/Modals/ApplyExternalContactsList/ExternalItem";
import { ManageNoticesStatus } from "@/types/chat/enum";
import noContent from "@/assets/img/search-nodata.png";

export interface ManageNoticeListInfo {
  applyReason: string;
  apprStatus: number; //  0:待审核, 1:审核通过, 2:审核驳回, 3:已失效
  deptName: string;
  applyDate: number; // 申请时间
  delayStartDate: number; // 延期时段始
  delayEndDate: number; // 延期字段止
  name: string;
  recordId: string;
  titleName: string;
  refuse?: boolean;
  loading?: boolean;
}

const limit = 20;

function ManageNoticeList({
  setManageExternalModal,
  manageExternalModal
}: {
  manageExternalModal: MangeExternalModalInfo;
  setManageExternalModal: Function;
}) {
  const { manageNoticeListVisible } = manageExternalModal;

  const [t] = useTranslation("chat");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [ManageNoticeList, setManageNoticeList] = useState<ManageNoticeListInfo[]>([]);

  useEffect(() => {
    async function getManageNoticeList() {
      const [result, error] = await getManagerApproveRecordsReq({
        pageNo: page,
        pageSize: limit
      });
      if (error) {
        message.error(error);
        return;
      }
      const { approveList, total } = result;

      setTotal(total);
      const newList: any = ManageNoticeList.concat(approveList).map((item: any) => {
        return {
          ...item,
          refuse: false,
          loading: false,
          applyReason: item?.applyReason
        };
      });

      setManageNoticeList(newList);
    }

    if (manageNoticeListVisible) {
      getManageNoticeList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manageNoticeListVisible, page]);

  const handleApplyAccountEXP = useCallback(
    async (item: any, apprStatus: number, apprOption?: string) => {
      const type = apprStatus;
      item.loading = true;

      const [result, error] = await approveAccountEXP({
        recordId: item?.recordId, // AI卡片里审核在extend中, 消息通知列表里参见返回的字段
        result: type === 2 ? 0 : 1, // 0:驳回, 1:通过
        apprOption: apprOption || ""
      });
      item.loading = false;
      if (error) {
        message.error(error);
        handleClouseRefuse(item, false);
        return;
      }
      const { status } = result;
      const newList: any = ManageNoticeList.map((n: any) => {
        if (item.recordId === n.recordId) {
          item.apprStatus = status === ManageNoticesStatus.SUCCESS ? type : 3;
          item.refuse = false;
          item.apprOption = apprOption;
        }
        return n;
      });
      setManageNoticeList(newList);
      setManageNoticeTipsTool(status);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ManageNoticeList]
  );
  const handleAdd = useCallback(
    (ele: any, type: number, refusalCause?: string) => {
      if (type === 1) {
        Modal.confirm({
          title: "提示",
          className: "manage-external-modal",
          content: (
            <>
              确定对该账号进行延期？
              <p className="confirmCon">延期后，账号有效期增加6个月</p>
            </>
          ),
          okText: "确定",
          cancelText: "取消",
          onOk() {
            handleApplyAccountEXP(ele, type, refusalCause);
          }
        });
        return;
      }
      handleApplyAccountEXP(ele, type, refusalCause);
    },
    [handleApplyAccountEXP]
  );

  function handleClose() {
    setManageExternalModal({ ...manageExternalModal, manageNoticeListVisible: false });
    setTimeout(() => {
      setPage(1);
      setTotal(0);
      setManageNoticeList([]);
    }, 100);
  }
  function handleClouseRefuse(item: any, type: boolean) {
    const newList: any = ManageNoticeList.map((n: any) => {
      if (item.recordId === n.recordId) {
        item.refuse = type;
      }
      return n;
    });
    setManageNoticeList(newList);
  }
  const titleNode = useCallback((item) => {
    return <>{item.name}的账号延期申请，请审核,</>;
  }, []);

  if (!manageNoticeListVisible) {
    return null;
  }
  return (
    <Modal
      title="消息通知"
      centered={true}
      visible={manageNoticeListVisible}
      onCancel={() => {
        handleClose();
      }}
      footer={null}
      width="720px"
      bodyStyle={{ height: 580, overflow: "auto" }}
    >
      <div className="external-contacts">
        {ManageNoticeList.length ? (
          ManageNoticeList.map((item: any, key) => {
            return (
              <ExternalItem
                data={item}
                key={key}
                handleClouseRefuse={(ele: any, type: boolean) => {
                  handleClouseRefuse(ele, type);
                }}
                handleAdd={(ele: any, type: number, refusalCause: string) => {
                  handleAdd(ele, type, refusalCause);
                }}
                titleNode={titleNode(item)}
                origin={2}
              />
            );
          })
        ) : (
          <Empty image={noContent} description="暂无数据" imageStyle={{ marginTop: 180 }} />
        )}

        {page * limit < total ? (
          <p
            style={{ cursor: "pointer", textAlign: "center" }}
            onClick={() => {
              setPage(page + 1);
            }}
          >
            {t("Load more")}
          </p>
        ) : (
          ""
        )}
      </div>
    </Modal>
  );
}

function mapStateToProps({ ebook }: { ebook: EbookState }) {
  return {
    manageExternalModal: {
      manageNoticeListVisible: ebook.manageExternalModal.manageNoticeListVisible
    }
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    setManageExternalModal(payload: boolean) {
      dispatch({ type: "ebook/setManageExternalModal", payload });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageNoticeList);
